import { NavigateNext } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

import Button from 'domains/core/components/Button';
import { FolderBreadcrumbData } from 'domains/core/components/folders/types';
import { Folder } from 'models/types';
import theme from 'theme';

import ModalItem from '../ModalItem';

const border = `1px solid ${theme.palette.primary.main}`;

const breadcrumbWrapperStyles = {
    padding: '0.5rem 1.5rem',
    borderTop: `1px solid ${theme.palette.primary.main}`,
    flexWrap: 'wrap',
};

const activeBreadcrumbStyles = {
    color: theme.palette.action.active,
    padding: 1,
};

const contentWrapperStyles = {
    borderTop: border,
    padding: '1rem 1rem 0',
};

type Props = {
    activeFolder: FolderBreadcrumbData;
    data: Folder[];
    folderTypeValue: string;
    getIsItemSelected: (item: Folder) => boolean;
    onDrillInto: (folder: Folder) => void;
    onGoToPathIndex: (index: number) => void;
    onGoToRoot: () => void;
    onSelectFutureLocation: (future: Folder) => void;
    path: Folder[];
    rootFolder: Folder;
};

const ModalPreviewItem = ({
    activeFolder,
    data,
    folderTypeValue,
    getIsItemSelected,
    onDrillInto,
    onGoToPathIndex,
    onGoToRoot,
    onSelectFutureLocation,
    path,
    rootFolder,
}: Props) => {
    const getDomainName = (name: string) => String(name).split(' ')[1].toLowerCase();

    const renderModalItems = () => {
        if (!data?.length) {
            return (
                <Typography align="center" sx={{ padding: '1rem' }} variant="body2">
                    No {getDomainName(rootFolder.name)} to preview.
                </Typography>
            );
        }

        return data.map((row) =>
            row.type === folderTypeValue ? (
                <ModalItem
                    key={row.id}
                    activeFolder={activeFolder}
                    isRowSelected={getIsItemSelected(row)}
                    row={row}
                    setFutureLocation={onSelectFutureLocation}
                    setPreviewedLocation={onDrillInto}
                />
            ) : (
                <ModalItem key={row.id} row={row} isPreview />
            )
        );
    };

    return (
        <>
            <Stack direction="row" sx={breadcrumbWrapperStyles}>
                <Button endIcon={<NavigateNext />} onClick={onGoToRoot} size="small" sx={{ padding: 1 }} variant="text">
                    {rootFolder.name}
                </Button>
                {path.map((folder, index) => {
                    const isCurrent = index === path.length - 1;

                    return (
                        <Button
                            key={folder.id}
                            disabled={isCurrent}
                            endIcon={isCurrent ? undefined : <NavigateNext />}
                            onClick={() => onGoToPathIndex(index)}
                            size="small"
                            sx={isCurrent ? activeBreadcrumbStyles : { padding: 1 }}
                            variant="text"
                        >
                            {folder.name}
                        </Button>
                    );
                })}
            </Stack>
            <Stack sx={contentWrapperStyles}>{renderModalItems()}</Stack>
        </>
    );
};

export default ModalPreviewItem;
